import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
} from '@mui/material';

import { Icon } from '../../../shared/Icon';

interface Props {
    open: boolean;
    code: string;
    onClose: () => void;
}

export const CSharpDialog = ({ open, code, onClose }: Props) => (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
            Generated C# Code
            <IconButton
                onClick={() => navigator.clipboard.writeText(code)}
                sx={{ float: 'right' }}
            >
                <Icon name="content_copy" />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <TextField
                fullWidth
                multiline
                minRows={6}
                value={code}
                slotProps={{
                    input: {
                        readOnly: true,
                        sx: { fontFamily: 'monospace', fontSize: 13 },
                    },
                }}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Close</Button>
        </DialogActions>
    </Dialog>
);
